import type { StyleRule } from '@archipro-design/aria';
import { pxArrayToRem, pxToRem } from '@archipro-design/aria';

export const AccordionTitleWrapper: StyleRule = ({ theme }) => ({
    width: '100%',
    cursor: 'pointer',
    justifyContent: 'space-evenly',
    display: 'inline-flex',
    height: pxToRem(56),
    paddingRight: pxToRem(18),
    userSelect: 'none',

    borderBottom: `2px ${theme.siteVariables.colors.charcoal[250]} solid`,
    [theme.screen.laptop]: {
        borderBottom: `2px ${theme.siteVariables.colors.grey[125]} solid`,
    },
});

export const AccordionIcon: StyleRule = ({ theme: { screen } }) => ({
    position: 'relative',
    bottom: pxToRem(1),
    right: pxToRem(1),
    margin: 'auto',

    [screen.min.tablet]: {
        height: pxToRem(24),
        width: pxToRem(24),
    },
});

export const AccordionTitle: StyleRule = ({
    theme: { siteVariables, screen },
}) => ({
    ...siteVariables.textStyles.Heading.Roman55,
    letterSpacing: siteVariables.letterSpacingSmall,
    color: siteVariables.colors.charcoal[250],
    fontSize: pxToRem(16),
    lineHeight: siteVariables.lineHeightDefault,
    textTransform: 'uppercase',
    width: 'inherit',
    margin: 'auto',

    [screen.min.tablet]: {
        letterSpacing: siteVariables.letterSpacingMedium,
        fontSize: pxToRem(16),
        lineHeight: pxToRem(21),
    },
});

export const AccordionContainer: StyleRule = () => ({
    minHeight: pxToRem(56),
});

export const ProductAwardGrid: StyleRule = ({ theme }) => ({
    display: 'grid',
    textAlign: 'end',
    columnGap: pxToRem(7),
    paddingTop: pxToRem(12),
    paddingBottom: pxToRem(12),
    borderBottom: `1px solid ${theme.siteVariables.colors.grey['300']}`,
    fontSize: pxToRem(16),

    [theme.screen.laptop]: {
        gridTemplateColumns: `${pxToRem(120)} ${pxToRem(260)} 1fr`,
        textAlign: 'unset',
        alignItems: 'center',
        minHeight: pxToRem(56),
        paddingLeft: pxToRem(14),
        paddingTop: 'unset',
        paddingBottom: 'unset',
    },
});

export const AwardOrg: StyleRule = ({ theme }) => ({
    fontWeight: 500,
    maxWidth: pxToRem(410),
    whiteSpace: 'normal',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    padding: pxArrayToRem([2, 0, 2, 0]),
    [theme.screen.laptop]: {
        padding: pxArrayToRem([16, 4, 16, 0]),
        maxWidth: pxToRem(260),
    },
});

export const AwardTitle: StyleRule = ({ theme }) => ({
    maxWidth: pxToRem(410),
    whiteSpace: 'normal',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    [theme.screen.laptop]: {
        maxWidth: pxToRem(480),
        border: 'none',
    },
});

export const IconContainer: StyleRule = ({ theme }) => ({
    width: pxToRem(18.67),
    justifyContent: 'center',
    position: 'relative',
    display: 'inline-flex',

    [theme.screen.laptop]: {
        height: 'unset',
        width: 'unset',
        margin: 'auto',
        position: 'relative',
        right: pxToRem(-3),
    },
});

export const AwardYear: StyleRule = ({ theme }) => ({
    color: theme.siteVariables.colors.charcoal[100],
    fontSize: pxToRem(14),
});
